import React from 'react';
import { Select } from 'components/atoms/select';
import { VirtualizedMenuList } from 'components/atoms/select/custom-components';
import { PLACEHOLDER } from 'components/organisms/task-pane/task-detail/task-fields/task-custom-fields/fields/constant';

export const BaseSelect = ({
  disabled = false,
  styles = {},
  isPlaceholderShown = true,
  components = {},
  ...props
}) => (
  <Select
    type="tag"
    isClearable
    isDisabled={disabled}
    placeholder={isPlaceholderShown ? PLACEHOLDER : undefined}
    components={{
      MenuList: VirtualizedMenuList,
      DropdownIndicator: null,
      IndicatorSeparator: null,
      ...components,
    }}
    menuPortalTarget={document.body}
    menuPlacement="auto"
    styles={{
      ...styles,
      menuPortal: (base) => ({
        ...base,
        zIndex: 'var(--zindex-popover-low)',
      }),
    }}
    {...props}
  />
);
